<template>
  <div id="left-1">
    <div class="area-title">
      <span>省份TOP5</span>
    </div>
    <div class="area-padding charts">
      <div class="charts-width" ref="topSellerRef"></div>
      <div class="charts-width" ref="topSocketRef"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      timer: null,
      topSellerChart: null,
      topSocketChart: null,
      timerId: null, //定时器的标识
      timerId2: null, //定时器的标识
      turnoverSeriesData: [],
      socketSeriesData: [],
    };
  },
  mounted() {
    this.init();
    this.getTopSellerData();
    this.getTopSocketData();
  },
  destroyed() {
    clearInterval(this.timerId);
    clearInterval(this.timerId2);
  },
  methods: {
    init() {
      this.topSellerChart = this.$echarts.init(this.$refs.topSellerRef);
      this.topSocketChart = this.$echarts.init(this.$refs.topSocketRef);
    },
    
    getTopSellerData() {
      this.turnoverSeriesData = [];
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/province"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: this.deviceType,
          regionId: this.regionId,
          level: this.level,
          sortType: 0,
        }),
      }).then(({ data }) => {
        // debugger
        if (data.code == 0) {
          if (data.data.provinceMapList.length > 0) {
            var top5Total = 0;
            for (var i = 0; i < 5; i++) {
              top5Total = top5Total + data.data.provinceMapList[i].value;
            }
            this.turnoverSeriesData = data.data.provinceMapList.slice(0, 5);
            this.turnoverSeriesData.push({
              name: "其他",
              value: 100 - top5Total,
            });
          }else{
            this.turnoverSeriesData= [{name:'',value:0}]
          }
          this.updateTopSellerChart();
        }
      });
    },
    getTopSocketData() {
      this.socketSeriesData = [];
      // 访问接口，获取 端口
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/province"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: this.deviceType,
          regionId: this.regionId,
          level: this.level,
          sortType: 1,
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          // var timeArry = [];
          
          if (
            data.data.provinceMapList.length > 0
          ) {
            var top5Total1 = 0;
            for (var i = 0; i < 5; i++) {
              top5Total1 = top5Total1 + data.data.provinceMapList[i].value;
            }
            this.socketSeriesData = data.data.provinceMapList.slice(0, 5);
            this.socketSeriesData.push({
              name: "其他",
              value: 100 - top5Total1,
            });
            // this.socketSeriesData = timeArry;
          }else{
            this.socketSeriesData=[{name:'',value:0}]
          }
          this.updateTopSocketChart();
        }
      });
      // this.startInterval();
    },
    updateTopSellerChart() {
      var option = {
        color: [
          // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#B620E0", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#E980F8", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#FFEE7A", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#F7B500", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#AEF2D6", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#30BC74", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#6FDDFF", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#0896FF", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#0070F7", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#0041EC", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          "#023166",
        ],
        title: [
          {
            show: true,
            text: "",
            textStyle: {
              color: "white",
              fontSize: 14,
              fontStyle: "normal",
              fontWeight: "normal",
            },
            top: "36%",
            left: "center",
          },
          {
            show: true,
            text: "",
            textStyle: {
              color: "white",
              fontSize: 18,
              fontStyle: "normal",
              fontWeight: "normal",
            },
            top: "48%",
            left: "center",
          },
          {
            show: true,
            text: "营业额",
            textStyle: {
              color: "#75B8FF",
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
            },
            top: "62%",
            left: "center",
          },
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["60%", "90%"],
            top: "10%",
            label: {
              normal: {
                show: false,
                rich: {
                  a: {
                    color: "#fff",
                    align: "center",
                    fontSize: 16,
                  },
                  b: {
                    color: "#fff",
                    align: "center",
                    fontSize: 20,
                  },
                },
                formatter: (params) => {
                  return (
                    "{a|" +
                    params.name +
                    "}\n{b|" +
                    params.value.toFixed(2) +
                    "%}"
                  );
                },
                position: "center",
              },
            },
            data: this.turnoverSeriesData,
          },
        ],
      };

      var count = 0;
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        if (count > 5) {
          this.topSellerChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: 5,
          });
          count = 0;
        }
        this.topSellerChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: count,
        });
        if (count !== 0) {
          this.topSellerChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: count - 1,
          });
        }
        option.title[0].text = option.series[0].data[count].name;
        option.title[1].text =
          option.series[0].data[count].value.toFixed(2) + "%";
        this.topSellerChart.setOption(option);
        count++;
      }, 1500);
    },
    // ================================更新端口数=============================
    updateTopSocketChart() {
      var dataTest = this.socketSeriesData;
      var option = {
        color: [
          // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#B620E0", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#E980F8", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#FFEE7A", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#F7B500", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#AEF2D6", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#30BC74", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#6FDDFF", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#0896FF", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#0070F7", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#0041EC", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          "#023166",
        ],
        title: [
          {
            show: true,
            text: "",
            textStyle: {
              color: "white",
              fontSize: 14,
              fontStyle: "normal",
              fontWeight: "normal",
            },
            top: "36%",
            left: "center",
          },
          {
            show: true,
            text: "",
            textStyle: {
              color: "white",
              fontSize: 18,
              fontStyle: "normal",
              fontWeight: "normal",
            },
            top: "48%",
            left: "center",
          },
          {
            show: true,
            text: "端口数",
            textStyle: {
              color: "#75B8FF",
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: "bold",
            },
            top: "62%",
            left: "center",
          },
        ],
        // calculable: true,
        series: [
          {
            name: "",
            type: "pie",
            radius: ["60%", "90%"],
            top: "10%",
            label: {
              normal: {
                show: false,
                rich: {
                  a: {
                    color: "#fff",
                    align: "center",
                    fontSize: 16,
                  },
                  b: {
                    color: "#fff",
                    align: "center",
                    fontSize: 20,
                  },
                },
                formatter: (params) => {
                  return "{a|" + params.name + "}\n{b|" + params.value + "%}";
                },
                position: "center",
              },
            },
            data: dataTest,
          },
        ],
      };
      var count = 0;
      if (this.timerId2) {
        clearInterval(this.timerId2);
      }
      this.timerId2 = setInterval(() => {
        if (count > 5) {
          this.topSocketChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: 5,
          });
          count = 0;
        }
        this.topSocketChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: count,
        });
        if (count !== 0) {
          this.topSocketChart.dispatchAction({
            type: "downplay",
            seriesIndex: 0,
            dataIndex: count - 1,
          });
        }
        option.title[0].text = option.series[0].data[count].name;
        option.title[1].text =
          option.series[0].data[count].value.toFixed(2) + "%";
        this.topSocketChart.setOption(option);
        count++;
      }, 1500);
    },
    // 定时器
    // startInterval() {
    //   var count2 = 0;
    //   if (this.timerId) {
    //     clearInterval(this.timerId);
    //   }
    //   this.timerId = setInterval(() => {
    //   }, 1500);
    // },
  },
};
</script>
<style lang="scss" scoped>
#left-1 {
  // height: 288px;
  width: 100%;
  // border: 1px solid red;
  .area-title {
    width: 284px;
    height: 32px;
    background: url("../../assets/pgzl-ranking-bg.png");
    background-size: cover;
    background-position: center center;
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    span {
      margin-left: 40px;
    }
  }
  .area-padding {
    padding: 0 16px;
  }
  .charts {
    width: 100%;
    // height: 256px;
    height: 170px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    .charts-width {
      width: 50%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/left-1.vue